import { render, staticRenderFns } from "./SaleTracking.vue?vue&type=template&id=eb24fade&scoped=true&"
import script from "./SaleTracking.vue?vue&type=script&lang=js&"
export * from "./SaleTracking.vue?vue&type=script&lang=js&"
import style0 from "./SaleTracking.vue?vue&type=style&index=0&id=eb24fade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb24fade",
  null
  
)

export default component.exports